import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "m11.999 3.453 7.443 4.274v1.14h-9.207v2.557h9.22v4.838h-9.22v2.556h4.748L12 20.535l-7.443-4.273v-1.14h9.22v-2.558h-9.22V7.727h9.22v-2.57H9.013L12 3.454zm0-2.953L1.97 6.25v11.5l10.029 5.75 10.029-5.75V6.25L11.998.5z" }));
export default createSvgIcon(iconPath, "Metahuman");
//# sourceMappingURL=MetahumanIcon.js.map